import axiosInstance from 'api/axiosConfig'
import handleApiError from 'api/utils/handleApiError';
import { Message } from 'components/types'

import { ENDPOINTS } from '../endpoints'

const useMessageService = () => {
  const loadMessages = async (): Promise<Message[]> => {
    try {
      const response = await axiosInstance.get<Message[]>(
        ENDPOINTS.MESSAGES.LOAD_MESSAGES
      )

      if (!response.data) {
        throw new Error()
      }

      return response.data
    } catch (err) {
      handleApiError('Failed to fetch messages', err)
      return []
    }
  };

  return { loadMessages }
}
  
export default useMessageService
